// 跳转类型
export enum JumpTypeEnum {
  H5 = 2, // H5
  MT_WXAPP = 3, // 团小程序
  MT_APP = 6, // 团APP
}